import { ContainerComponent, wrap } from 'AppReact';
import { FilterHeaderWrapper, RowCenterScrollWrapper, WhiteSpaceNoWrap } from 'wrappers';
import { SecondaryTextXs, BorderlessKeyInput } from 'atoms';
import { DropdownTextButton } from 'molecules';
import Controller from './controller';
import internalState from './internalState';

export const definition = {
  name: 'MultipleTermSearch',
  initialProps: ({ searchTerms, label }) => ({ searchTerms, label }),
  props: internalState,
  controller: Controller,
  elements: [
    {
      component: wrap(SecondaryTextXs, WhiteSpaceNoWrap),
      name: 'Label',
      displayValue: ({ label }) => label ?? 'Filter by search term:',
    },
    {
      wrapper: RowCenterScrollWrapper,
      name: 'Wrapper',
      elements: [
        {
          component: DropdownTextButton,
          name: 'SelectedButton',
          isListOf: 'searchTerms',
          bindings: ({ searchTerm, searchTerms }) => ({ text: searchTerm, searchTerms })
        },
        {
          component: BorderlessKeyInput,
          name: 'SearchInput',
          bindings: ({ value, searchTerms }) => ({ value, placeholder: "Search...", searchTerms })
        }
      ]
    }
  ]
}

const MultipleTermSearch = ContainerComponent(definition)

export default wrap(MultipleTermSearch, FilterHeaderWrapper)